export enum InitialScreens {
  AUTHENTICATION = 'authentication'
}
